import type { IconData } from '@stacksjs/iconify-core'

export const exclamationCircle: IconData = {
  "body": "<circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"12\" cy=\"16\" r=\"1\" fill=\"currentColor\"/><path fill=\"currentColor\" d=\"M12 13a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default exclamationCircle
